import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const manualVolumeStyles = makeStyles(theme => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  backgroundWhite: {
    backgroundColor: themeColor.white,
  },
  manualVolumeTitleBar: {
    color: themeColor.infoMain,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
  },
  manualVolumeTitleHeader: {
    color: themeColor.modalTitle,
  },
  manualVolumeTitleHeaderLabel: {
    fontWeight: 500,
    '@media (max-height: 1080px)': {
      fontSize: rem(3),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(2.7),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(2.5),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(3),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(2),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(2),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(1.7),
    },
  },
  manualVolumeContainer: {
    padding: 10,
  },
  keypadContainer: {
    alignSelf: 'flex-end',
  },
  outerMostContainer: {
    width: '0',
    marginLeft: '1vh',
  },
  fitHeight: {
    height: 'fit-content',
  },
  containerAlignment: {
    alignSelf: 'flex-end',
    justifyContent: 'center',
  },
  selfAlign: {
    alignSelf: 'flex-end',
  },
  outerFlexDesign: {
    flex: '1 1 0',
  },
  flexDesign: {
    flex: 1,
  },
  cancelButton: {
    marginRight: '1.3280vh',
  },
  itemContent: {
    marginLeft: '6vw',
    marginRight: '6vw',
  },
  manualVolumeTitle: {
    fontWeight: 500,
    '@media (max-height: 1080px)': {
      fontSize: rem(2.7),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(2.4),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(2.2),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(2.7),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(1.7),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(1.7),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(1.4),
    },
    paddingRight: '0.5vw',
  },
  quantityLinePieces: {
    fontWeight: 500,
    '@media (max-height: 1080px)': {
      fontSize: rem(1.7),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(1.5),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1.5),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.5),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(1.2),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(1),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(0.8),
    },
  },
  quantityLineColor: {
    color: themeColor.subheaderLight,
  },
  quantityLinePadding: {
    paddingRight: '0.5vw',
  },
  unitPriceContainer: {
    justifyContent: 'flex-end',
  },
  descriptionWithPriceContainer: {
    justifyContent: 'space-between',
  },
  topMargin: {
    marginTop: '6vh',
  },
  descriptionStyle: {
    gap: rem(1),
    fontWeight: 500,
    '@media (max-height: 1080px)': {
      fontSize: rem(2),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(1.5),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(2.1),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(1.3),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(1.2),
    },
  },
}));
